import {
  SET_TENANT_SUBSCRIPTION,
  SET_CUSTOMER_SUBSCRIPTION,
  SET_CUSTOMER_SUBSCRIPTION_IS_LOADING,
  SET_STRIPE_CUSTOMER_DETAILS,
  SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
  SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING,
  SET_SELECTED_SUBSCRIPTION,
  SET_SUBSCRIPTION_IS_LOADING,
  SET_CUSTOMER_SUBSCRIPTION_DONE_FETCHING,
} from "redux/constants/portal";

const initialState = {
  tenantSubscription: null,
  customerSubscription: null,
  isCustomerSubscriptionLoading: false,
  stripeCustomerDetails: null,
  isStripeCustomerDetailsLoading: false,
  numberOfRemainingActiveFlowsAndExecutions: null,
  selectedSubscription: null,
  isSubscriptionLoading: false,
  isCustomerSubscriptionDoneFetching: false,
};

const subscriptions = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TENANT_SUBSCRIPTION:
      return {
        ...state,
        tenantSubscription: payload,
      };
    case SET_CUSTOMER_SUBSCRIPTION:
      return {
        ...state,
        customerSubscription: payload,
      };
    case SET_CUSTOMER_SUBSCRIPTION_DONE_FETCHING:
      return {
        ...state,
        isCustomerSubscriptionDoneFetching: true,
      };
    case SET_CUSTOMER_SUBSCRIPTION_IS_LOADING:
      return {
        ...state,
        isCustomerSubscriptionLoading: payload,
      };
    case SET_STRIPE_CUSTOMER_DETAILS:
      return {
        ...state,
        stripeCustomerDetails: payload,
      };
    case SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS:
      return {
        ...state,
        numberOfRemainingActiveFlowsAndExecutions: payload,
      };
    case SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING:
      return {
        ...state,
        isStripeCustomerDetailsLoading: payload,
      };
    case SET_SELECTED_SUBSCRIPTION:
      return {
        ...state,
        selectedSubscription: payload,
      };
    case SET_SUBSCRIPTION_IS_LOADING:
      return {
        ...state,
        isSubscriptionLoading: payload,
      };
  }
  return state;
};

export default subscriptions;
